import {
  CovSensorParamPeriodDtoType,
  CovSensorStatus,
  PlanningDay,
  PlanningType,
  type Planning,
} from "@eisox/api/core-api";
import { z } from "@eisox/zod";

import { m } from "~/paraglide/messages";

export const covSensorPeriodSchema = z.object({
  day: z.enum(PlanningDay),
  hourStart: z.string(),
  hourEnd: z.string(),
  type: z.enum(CovSensorParamPeriodDtoType),
});

export type CovSensorFormPeriod = z.infer<typeof covSensorPeriodSchema>;

export const COV_SENSOR_UPDATE_PLANNING_TYPES = [PlanningType.ENABLED] as const;

export const covFormPeriodsToPlanning = (periods: CovSensorFormPeriod[]): Planning[] =>
  periods.map(period => ({
    day: period.day,
    hourStart: period.hourStart,
    hourEnd: period.hourEnd,
    type: PlanningType.ENABLED,
    userDefined: true,
  }));

export const getCovSensorStatusLabel = (status: CovSensorStatus): string => {
  switch (status) {
    case CovSensorStatus.ENABLED:
      return m.activation({ activation: "true" });
    case CovSensorStatus.DISABLED:
      return m.activation({ activation: "false" });
    case CovSensorStatus.PERIODS:
      return m.activate_by_timeslot();
    case CovSensorStatus.PRESENCE:
      return m.activate_on_presence_timeslot();
  }
};
